import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventName, GATrackingEventType } from '../../constants';
import { Product } from '~shared/models';

import { PageNameTypes } from '~shared/modules/application-event/constants';

export class GATRackingAlternativeProductClickEvent implements GATrackingEvent {

  constructor(
    private product: Product,
    private pageType: PageNameTypes) {

  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.AlternativeProductClick;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.AlternativeProducts,
      label: `${this.pageType}, ${this.product.name}`
    };
  }
}
